/*
  Product page "0% Finance" tab - see snippets/jj-finance-tab.liquid.

  1. Templates with no finance tab of their own get one rendered at the end of
     the product info column; move it above "Stock Source" (or after the last
     tab, which is normally Old Furniture Removal) so it sits with the others.
  2. "Add to cart & checkout with Klarna" presses the REAL Add to cart button,
     so the delivery date gate, the removal upsell and the "already in your
     basket" handling all behave exactly as normal, then goes to checkout once
     the add has succeeded. If the add is blocked or fails, the button resets
     and the normal message shows.
  3. Arriving from a product card's "See finance options" link
     (<url>#finance) opens the tab.
  4. "Check your purchase power" opens Klarna's own calculator by pressing
     the button in Klarna's widget under the price (the widget is Klarna's
     app block; its button lives in an open shadow root). If Klarna ever
     changes that markup, the link falls back to scrolling to the widget;
     pages without the widget drop the link.
  5. On a variant change the tab's figures are copied from the section HTML
     the theme has just fetched, so the price rule stays in Liquid
     (snippets/klarna-monthly.liquid) and is never duplicated here.
*/
(function () {
  if (window.jjFinanceTabReady) return;
  window.jjFinanceTabReady = true;

  var CHECKOUT_URL = '/checkout';
  var BACKSTOP_MS = 8000;
  var ACCEPT_MS = 700;

  function placeAutoTabs() {
    document.querySelectorAll('[data-jj-finance-auto]').forEach(function (tab) {
      var column = tab.parentElement;
      if (!column) return;
      var tabs = Array.prototype.filter.call(column.children, function (el) {
        return el !== tab && (el.classList.contains('product__accordion') || el.classList.contains('removal-upsell'));
      });
      if (!tabs.length) return;
      var stock = tabs.filter(function (el) {
        return /stock source/i.test(el.textContent);
      })[0];
      if (stock) column.insertBefore(tab, stock);
      else tabs[tabs.length - 1].after(tab);
    });
  }

  function cartHas(variantId) {
    return fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (i) { return i.variant_id === variantId; });
      });
  }

  function setBusy(btn, busy) {
    btn.classList.toggle('is-loading', busy);
    if (busy) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  }

  function onKlarnaCheckout(btn) {
    var sectionId = btn.dataset.sectionId;
    var submit = document.getElementById('ProductSubmitButton-' + sectionId);
    var form = document.getElementById('product-form-' + sectionId);
    if (!submit || !form) {
      window.location = window.routes.cart_url;
      return;
    }

    // Sold out / unavailable variant: Add to cart cannot be pressed at all.
    if (submit.disabled) return;
    // Gated (e.g. delivery date required): pressing Add to cart shows the
    // gate's own notice; there is nothing to wait for.
    if (submit.getAttribute('aria-disabled') === 'true') {
      submit.click();
      return;
    }

    var variantId = Number(new FormData(form).get('id'));
    var done = false;
    var unsubs = [];
    var backstop;
    setBusy(btn, true);

    function finish(ok) {
      if (done) return;
      done = true;
      clearTimeout(backstop);
      unsubs.forEach(function (u) { if (typeof u === 'function') u(); });
      if (ok) window.location = CHECKOUT_URL;
      else setBusy(btn, false);
    }

    cartHas(variantId)
      .catch(function () { return false; })
      .then(function (already) {
        // Already in the basket (outlet stock is one-of-one): straight to checkout.
        if (already) return finish(true);

        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
          unsubs.push(subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
            if (e && e.source === 'product-form') finish(true);
          }));
          unsubs.push(subscribe(PUB_SUB_EVENTS.cartError, function () { finish(false); }));
        }
        // Backstop for paths that publish nothing (e.g. "already in basket"
        // with a removal line): ask the basket directly.
        backstop = setTimeout(function () {
          cartHas(variantId).then(finish).catch(function () { finish(false); });
        }, BACKSTOP_MS);

        submit.click();

        // Safety net: Add to cart shows its spinner as soon as it accepts the
        // click. If it did not, something stopped it - give the button back.
        setTimeout(function () {
          if (!done && !submit.classList.contains('loading')) finish(false);
        }, ACCEPT_MS);
      });
  }

  function klarnaWidget() {
    return document.querySelector('klarna-placement');
  }

  function openKlarnaCalculator() {
    var widget = klarnaWidget();
    if (!widget) return;
    var cta = widget.shadowRoot && widget.shadowRoot.querySelector('button, a');
    if (cta) cta.click();
    else widget.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function dropPurchasePowerIfNoWidget() {
    if (klarnaWidget()) return;
    document.querySelectorAll('[data-jj-klarna-more]').forEach(function (el) { el.remove(); });
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.html) return;
    var fresh = data.html.querySelector('.jj-finance-tab');
    var tab = document.querySelector('.jj-finance-tab');
    if (!fresh || !tab) return;

    // [selector, where it lives, add at end of parent?]
    [
      ['.jj-finance-tab__pill', '.summary__title', true],
      ['.jj-finance-tab__klarna', '.accordion__content', false],
    ].forEach(function (part) {
      var current = tab.querySelector(part[0]);
      var next = fresh.querySelector(part[0]);
      if (current && next) {
        current.replaceWith(next);
      } else if (current) {
        current.remove();
      } else if (next) {
        var parent = tab.querySelector(part[1]);
        if (!parent) return;
        if (part[2]) parent.append(next);
        else parent.prepend(next);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-jj-klarna-checkout]');
    if (btn && btn.getAttribute('aria-busy') !== 'true') onKlarnaCheckout(btn);
    if (event.target.closest('[data-jj-klarna-more]')) openKlarnaCalculator();
  });

  function openFromHash() {
    if (window.location.hash !== '#finance') return;
    var tab = document.getElementById('finance');
    var details = tab && tab.querySelector('details');
    if (!details) return;
    details.open = true;
    // Title to the top: an open tab can be taller than a phone screen, so
    // centring it hid the title. The gap for the sticky header is the
    // scroll-margin-top in component-jj-finance-tab.css.
    tab.scrollIntoView({ block: 'start' });
  }

  function init() {
    placeAutoTabs();
    openFromHash();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // The old furniture removal tab also moves itself after the last tab, so
  // place again once every script has run - finance then follows removal, the
  // same order as templates that have their own finance tab.
  window.addEventListener('load', function () {
    placeAutoTabs();
    openFromHash();
    dropPurchasePowerIfNoWidget();
  });
})();
